// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.logincontainer {
  position: relative;
  height:  100vh;
  overflow: hidden;
  text-align: left;
  font-family: var(--inter-body-1-medium);

  /*Text Font*/
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.44px;
}

.backimage {
  position: absolute;
  z-index: -1; /* This ensures that the background is rendered behind other elements */
  top: 0;
  left: 0;
  height: 100%;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Logo Styles */
.logo-circle-blurred {
  top: 23%;
  left: 48%;
}

.logo-1-icon,
.logo-circle-blurred,
.logoclaim-1-icon {
  position: absolute;
  overflow: hidden;
}

.logo-1-icon {
  height: 13%;
  top: 43%;
  left: 42%;
}

.logoclaim-1-icon {
  top: 30px;
  left: 30px;
  width: 400px;
  height: 121.1px;
}

/* Password Styles */
.password {
  border: none;
  outline: none;
  font-weight: 300;
  font-family: var(--inter-body-1-medium);
  font-size: var(--inter-body-big-size);
  background-color: transparent;
  position: absolute;
  width: calc(100% - 99px);
  top: calc(50% - 16px);
  left: 83px;
  line-height: 32px;
  color: var(--gray-50);
  text-align: left;
  display: flex;
  align-items: center;
}

/* User Icon Styles */
.search-56dp,
.user-icon {
  position: absolute;
  top: 215px;
  left: 0;
  width: 550px;
  height: 70px;
}

.user-icon {
  top: 12px;
  left: 23px;
  width: 45px;
  height: 45px;
}

.search-56dp1 {
  position: absolute;
  top: 98px;
  left: 0;
  width: 550px;
  height: 70px;
}

/* Button Styles */
.button-filled-m {
  cursor: pointer;
  border: 0;
  padding: 0;
  position: relative;
  width: 550px;
  height: 70px;
  background-color: var(--white-base);
  border-radius: var(--br-mini);
  transition: background-color 0.3s ease;
}

.button-icon-light,
.button-icon-light1 {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 48px;
  height: 48px;
}

.button-icon-light1 {
  right: 108px;
}

/* Icon Styles */
.icon {
  position: relative;
  width: 50px;
  height: 50px;
  overflow: hidden;
  flex-shrink: 0;
}

/* Digital Reifegrad and Logo Styles */
.digital-reifegrad,
.logo {
  display: flex;
  align-items: center;
}

.digital-reifegrad {
  position: relative;
  line-height: 36px;
  width: fit-content;
  height: fit-content;
  flex-shrink: 0;
}

.logo {
  position: absolute;
  width: calc(100% - 1665px);
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  height: fit-content;
  height: 3%;
  flex-direction: row;
  justify-content: flex-start;
  gap: var(--gap-9xs);
  font-size: var(--inter-24-sp-h5-size);
}

/* Login Form Styles */
.Login-Parent {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 36%;
  left: 9%;
  width: 30%;
  height: auto;
  gap: 30px;
}

.Login-Title{  
  font-size: var(--inter-30-sp-h3-size);
  top: 0;
  left: 0;
  font-weight: 500;
}

.Login-div {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  background-color: var(--white-base);
  box-sizing: border-box;
  padding: 0 10px; /* Adjust the values as needed for left and right padding */
}

.Login-input {
  outline: none;
  font-family: var(--inter-body-1-medium);
  font-size: var(--inter-body-big-size);
  line-height: 32px;
  width: 100%;
  color: var(--gray-50);
  text-align: left;
  padding: 8px;
  border: none; /* Add this line to remove the border */
  padding: 0 0 0 15px;
}

.Login-icon{
  padding: 5px;
  width: 35px;
  height: 35px;
}

.pwc_container {
  position: fixed;
  bottom: 10px;
  left: 10px;
  height: 100px;
  display: flex;
  justify-content: center; /* Center children horizontally */
  align-items: center; /* Center children vertically */
  width: fit-content;
}


.pwc-img{
  position: relative;
  width: 100px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  z-index: 999;
}


/*Messages*/

.Password-Container{
  flex-direction: column;
  display: flex;
}

.Forgot-Password-Container{
  width: 100%;
  height: fit-content;
}

.Forgot-Password {
  position: relative;
  font-size: var(--inter-body-1-medium-size);
  cursor: pointer;
  background-color: transparent;
  width: fit-content;
  font-weight: 500;
  font-family: var(--inter-body-1-medium);
  color: var(--primary);
  float: right;
}

.error-message {
  position: absolute;
  bottom: 115px;
  left: 0px;
  letter-spacing: 0.44px;
  line-height: 24px;
  font-size: 18px; /* Adjusted font size for similarity */
  font-weight: 500;
  font-family: var(--inter-body-1-medium);
  color: #8B0000; /* Colored the text red */
  text-align: left;
  display: inline-block;
  width: 340px;
  background-color: rgba(255, 0, 0, 0); /* Optional: Add a background color for better visibility */
}

.Login-Button {
  display: flex;
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--borderColor);
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 10px;
  background-color: var(--white-base);
  box-sizing: border-box;
  font-size: var(--inter-24-sp-h5-size);
  font-family: var(--inter-body-1-medium);
  font-weight: bold;
  color: var(--gray-50);
}

.Register-Formate {
  display: flex;
  align-items: center; /* Center children vertically */
  justify-content: center; /* Center children horizontally */
  outline: none;
  font-family: var(--inter-body-1-medium);
  font-size: var(--inter-body-1-medium-size);
  color: var(--white-base);
  line-height: 32px;
  font-weight: 500;
  width: 100%;
  text-align: left;
  border: none;
}

.Konto-Erstellen{  
  color: var(--primary);
  cursor: pointer;
  margin-left: 10px;
}

.login-version{
  position: absolute;
  top: 10px;
  right: 10px;
  color: var(--gray-60);
  -webkit-user-select: none;
          user-select: none;

  /* TEXT STYLE */
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,uEAAuE;EACpF,MAAM;EACN,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;;EAEE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;EACtB,eAAe,EAAE,2DAA2D;AAC9E;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,YAAY,EAAE,uCAAuC;EACrD,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,mBAAmB,EAAE,+BAA+B;EACpD,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;;AAGA,WAAW;;AAEX;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe,EAAE,sCAAsC;EACvD,gBAAgB;EAChB,uCAAuC;EACvC,cAAc,EAAE,yBAAyB;EACzC,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,oCAAoC,EAAE,2DAA2D;AACnG;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;EACrC,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,+BAA+B;EACpD,uBAAuB,EAAE,iCAAiC;EAC1D,aAAa;EACb,uCAAuC;EACvC,0CAA0C;EAC1C,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;;EAEjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* General Styles */\r\n.logincontainer {\r\n  position: relative;\r\n  height:  100vh;\r\n  overflow: hidden;\r\n  text-align: left;\r\n  font-family: var(--inter-body-1-medium);\r\n\r\n  /*Text Font*/\r\n  font-family: Inter;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.44px;\r\n}\r\n\r\n.backimage {\r\n  position: absolute;\r\n  z-index: -1; /* This ensures that the background is rendered behind other elements */\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  background-size: 100% 100%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-attachment: fixed;\r\n}\r\n\r\n/* Logo Styles */\r\n.logo-circle-blurred {\r\n  top: 23%;\r\n  left: 48%;\r\n}\r\n\r\n.logo-1-icon,\r\n.logo-circle-blurred,\r\n.logoclaim-1-icon {\r\n  position: absolute;\r\n  overflow: hidden;\r\n}\r\n\r\n.logo-1-icon {\r\n  height: 13%;\r\n  top: 43%;\r\n  left: 42%;\r\n}\r\n\r\n.logoclaim-1-icon {\r\n  top: 30px;\r\n  left: 30px;\r\n  width: 400px;\r\n  height: 121.1px;\r\n}\r\n\r\n/* Password Styles */\r\n.password {\r\n  border: none;\r\n  outline: none;\r\n  font-weight: 300;\r\n  font-family: var(--inter-body-1-medium);\r\n  font-size: var(--inter-body-big-size);\r\n  background-color: transparent;\r\n  position: absolute;\r\n  width: calc(100% - 99px);\r\n  top: calc(50% - 16px);\r\n  left: 83px;\r\n  line-height: 32px;\r\n  color: var(--gray-50);\r\n  text-align: left;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* User Icon Styles */\r\n.search-56dp,\r\n.user-icon {\r\n  position: absolute;\r\n  top: 215px;\r\n  left: 0;\r\n  width: 550px;\r\n  height: 70px;\r\n}\r\n\r\n.user-icon {\r\n  top: 12px;\r\n  left: 23px;\r\n  width: 45px;\r\n  height: 45px;\r\n}\r\n\r\n.search-56dp1 {\r\n  position: absolute;\r\n  top: 98px;\r\n  left: 0;\r\n  width: 550px;\r\n  height: 70px;\r\n}\r\n\r\n/* Button Styles */\r\n.button-filled-m {\r\n  cursor: pointer;\r\n  border: 0;\r\n  padding: 0;\r\n  position: relative;\r\n  width: 550px;\r\n  height: 70px;\r\n  background-color: var(--white-base);\r\n  border-radius: var(--br-mini);\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.button-icon-light,\r\n.button-icon-light1 {\r\n  position: absolute;\r\n  top: 30px;\r\n  right: 30px;\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n\r\n.button-icon-light1 {\r\n  right: 108px;\r\n}\r\n\r\n/* Icon Styles */\r\n.icon {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Digital Reifegrad and Logo Styles */\r\n.digital-reifegrad,\r\n.logo {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.digital-reifegrad {\r\n  position: relative;\r\n  line-height: 36px;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.logo {\r\n  position: absolute;\r\n  width: calc(100% - 1665px);\r\n  top: 5%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: fit-content;\r\n  height: fit-content;\r\n  height: 3%;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  gap: var(--gap-9xs);\r\n  font-size: var(--inter-24-sp-h5-size);\r\n}\r\n\r\n/* Login Form Styles */\r\n.Login-Parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 36%;\r\n  left: 9%;\r\n  width: 30%;\r\n  height: auto;\r\n  gap: 30px;\r\n}\r\n\r\n.Login-Title{  \r\n  font-size: var(--inter-30-sp-h3-size);\r\n  top: 0;\r\n  left: 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.Login-div {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  background-color: var(--white-base);\r\n  box-sizing: border-box;\r\n  padding: 0 10px; /* Adjust the values as needed for left and right padding */\r\n}\r\n\r\n.Login-input {\r\n  outline: none;\r\n  font-family: var(--inter-body-1-medium);\r\n  font-size: var(--inter-body-big-size);\r\n  line-height: 32px;\r\n  width: 100%;\r\n  color: var(--gray-50);\r\n  text-align: left;\r\n  padding: 8px;\r\n  border: none; /* Add this line to remove the border */\r\n  padding: 0 0 0 15px;\r\n}\r\n\r\n.Login-icon{\r\n  padding: 5px;\r\n  width: 35px;\r\n  height: 35px;\r\n}\r\n\r\n.pwc_container {\r\n  position: fixed;\r\n  bottom: 10px;\r\n  left: 10px;\r\n  height: 100px;\r\n  display: flex;\r\n  justify-content: center; /* Center children horizontally */\r\n  align-items: center; /* Center children vertically */\r\n  width: fit-content;\r\n}\r\n\r\n\r\n.pwc-img{\r\n  position: relative;\r\n  width: 100px;\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n  margin-bottom: 20px;\r\n  z-index: 999;\r\n}\r\n\r\n\r\n/*Messages*/\r\n\r\n.Password-Container{\r\n  flex-direction: column;\r\n  display: flex;\r\n}\r\n\r\n.Forgot-Password-Container{\r\n  width: 100%;\r\n  height: fit-content;\r\n}\r\n\r\n.Forgot-Password {\r\n  position: relative;\r\n  font-size: var(--inter-body-1-medium-size);\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  width: fit-content;\r\n  font-weight: 500;\r\n  font-family: var(--inter-body-1-medium);\r\n  color: var(--primary);\r\n  float: right;\r\n}\r\n\r\n.error-message {\r\n  position: absolute;\r\n  bottom: 115px;\r\n  left: 0px;\r\n  letter-spacing: 0.44px;\r\n  line-height: 24px;\r\n  font-size: 18px; /* Adjusted font size for similarity */\r\n  font-weight: 500;\r\n  font-family: var(--inter-body-1-medium);\r\n  color: #8B0000; /* Colored the text red */\r\n  text-align: left;\r\n  display: inline-block;\r\n  width: 340px;\r\n  background-color: rgba(255, 0, 0, 0); /* Optional: Add a background color for better visibility */\r\n}\r\n\r\n.Login-Button {\r\n  display: flex;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  border: 1px solid var(--borderColor);\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  background-color: var(--white-base);\r\n  box-sizing: border-box;\r\n  font-size: var(--inter-24-sp-h5-size);\r\n  font-family: var(--inter-body-1-medium);\r\n  font-weight: bold;\r\n  color: var(--gray-50);\r\n}\r\n\r\n.Register-Formate {\r\n  display: flex;\r\n  align-items: center; /* Center children vertically */\r\n  justify-content: center; /* Center children horizontally */\r\n  outline: none;\r\n  font-family: var(--inter-body-1-medium);\r\n  font-size: var(--inter-body-1-medium-size);\r\n  color: var(--white-base);\r\n  line-height: 32px;\r\n  font-weight: 500;\r\n  width: 100%;\r\n  text-align: left;\r\n  border: none;\r\n}\r\n\r\n.Konto-Erstellen{  \r\n  color: var(--primary);\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n.login-version{\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  color: var(--gray-60);\r\n  user-select: none;\r\n\r\n  /* TEXT STYLE */\r\n  font-family: Poppins;\r\n  font-size: 10px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
